import { Component } from '@angular/core';

@Component({
  selector: 'app-progress-bar-widget-skeleton',
  templateUrl: './progress-bar-widget-skeleton.component.html',
  styleUrls: ['./progress-bar-widget-skeleton.component.scss'],
})
export class ProgressBarWidgetSkeletonComponent {}
